import { render, staticRenderFns } from "./_rename_record_form.vue?vue&type=template&id=c5ed28a4&"
import script from "./_rename_record_form.vue?vue&type=script&lang=js&"
export * from "./_rename_record_form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports